import { cn } from '../../../../lib/utils.ts'

export function ItemSeparator(props: ItemSeparator.Props) {
  const { className, ...rest } = props
  return (
    <div role="separator" data-slot="item-separator" className={cn('h-px bg-line-base-basic', className)} {...rest} />
  )
}
export namespace ItemSeparator {
  export type Props = React.ComponentProps<'div'>
}
